import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import {
  AutoWithdrawalsConfigDTO,
  AutoWithdrawalTierDTO,
  BinRangeExclusionDTO,
  TiersPrioritiesDTO,
} from './auto-withdrawals-config.model';

@Injectable()
export class AutoWithdrawalsConfigService {
  constructor(private httpClient: HttpClient) {}

  getAutoWithdrawalsConfig(): Observable<AutoWithdrawalsConfigDTO> {
    return this.httpClient.get<AutoWithdrawalsConfigDTO>('/auto-withdrawals-config');
  }

  updateAutoWithdrawalsConfig(config: AutoWithdrawalsConfigDTO) {
    return this.httpClient.put('/auto-withdrawals-config', config);
  }

  getTier(id: number): Observable<AutoWithdrawalTierDTO> {
    return this.httpClient.get<AutoWithdrawalTierDTO>(`/auto-withdrawals-config/tier/${id}`);
  }

  updateTier(id: number, tier: AutoWithdrawalTierDTO) {
    return this.httpClient.put(`/auto-withdrawals-config/tier/${id}`, tier);
  }

  insertTier(tier: AutoWithdrawalTierDTO) {
    return this.httpClient.post('/auto-withdrawals-config/tier', tier);
  }

  removeTier(id: number) {
    return this.httpClient.delete(`/auto-withdrawals-config/tier/${id}`);
  }

  reorder(priorities: TiersPrioritiesDTO) {
    return this.httpClient.put('/auto-withdrawals-config/tiers/reorder', priorities);
  }

  getBinRangeExclusion(id: number): Observable<BinRangeExclusionDTO> {
    return this.httpClient.get<BinRangeExclusionDTO>(`/auto-withdrawals-config/bin-range-exclusion/${id}`);
  }

  updateBinRangeExclusion(id: number, binRangeExclusion: BinRangeExclusionDTO) {
    return this.httpClient.put(`/auto-withdrawals-config/bin-range-exclusion/${id}`, binRangeExclusion);
  }

  insertBinRangeExclusion(binRangeExclusion: BinRangeExclusionDTO) {
    return this.httpClient.post('/auto-withdrawals-config/bin-range-exclusion', binRangeExclusion);
  }

  removeBinRangeExclusion(id: number) {
    return this.httpClient.delete(`/auto-withdrawals-config/bin-range-exclusion/${id}`);
  }
}
